import { TenantProvider } from '../../common/TenantPersona';

export default class PicProvider extends TenantProvider<{}> {}
